// Lazy Leaflet loader — the map library (~150 kB + css) loads only when a
// screen actually needs it (the estimator), instead of on every page load
// like the old CDN <script> in <head>. Publishes window.L because the
// imperative map code (and lib/slope.ts) reads the global at call time.

let pending: Promise<any> | null = null;

export function ensureLeaflet(): Promise<any> {
  const w = window as any;
  if (w.L && w.L.map) return Promise.resolve(w.L);
  if (!pending) {
    pending = Promise.all([
      import("leaflet"),
      import("leaflet/dist/leaflet.css"),
    ]).then(([mod]) => {
      const L = (mod as any).default || mod;
      w.L = L;
      return L;
    });
  }
  return pending;
}

// Take a map down without it taking the page with it. `remove()` in the middle
// of a zoom animation (a fitBounds that just started, a pinch) lets Leaflet's
// transition-end handler run against panes that are already gone, which is the
// "Cannot read properties of undefined (reading '_leaflet_pos')" the ops page
// collects from /estimator. Stop the animation, drop the listeners, then remove;
// a map that is already gone is not an error.
export function destroyMap(m: any): void {
  if (!m) return;
  try { if (typeof m.stop === "function") m.stop(); } catch { /* already gone */ }
  try { m.off(); } catch { /* already gone */ }
  try { m.remove(); } catch { /* already gone */ }
}
